const env = {
    active: 'preview',//preview,dev
    baseUrl: '/design',
    fileUrl: '/file',
    version: '0.9.2',
}
export const baseUrl = env.baseUrl
export const fileUrl = env.fileUrl
export default env
